import React, {Component} from "react";
import { Link } from 'react-router-dom';
import UsersBanksTable from './table'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { CustomButton } from '../../../uikit/Button';
import "./style.scss";
class UsersBanks extends Component {

    render() {
        return (
            <div style={{position: 'relative'}}>
                <div className='goBack'>
                    <div style={{paddingBottom: 30}} className={"backLink backBtn titleWrapper"}>
                        {/* <Link
                            to="#" 
                            onClick={() => { this.props.history.goBack(); }} 
                            style={{float: 'left', paddingTop:5, fontSize: 13, fontWeight: 400, color: '#9199AA'}}
                        >
                            <ArrowLeftOutlined style={{ marginRight: 14 }} />
                            Gå tillbaka
                        </Link> */}
                        <h2 className='text-center'>Ska vara användare</h2>
                    </div>
                </div>
                <div className="usersBanksTableWrapper">
                    <div style={{display: 'flex', justifyContent: 'flex-end', paddingRight: '16px'}}>
                        <Link to={`${'/users/banks/new'}`}>
                            <CustomButton 
                                buttontype="type5"
                                colortype="type8"
                                size="large"
                                style={{margin: '0 10px 20px', minWidth: '215px'}}
                            >
                                Lägg till bank
                            </CustomButton>
                        </Link>
                    </div>
                    <UsersBanksTable />
                </div>
            </div>
        );
    }
}

export default UsersBanks;